import EnvironmentDefs from '../../EnvironmentDefs';

const {
    Environment,
    Network,
    RecordSource,
    Store,
} = require('relay-runtime');

const store = new Store(new RecordSource());

const envDefs = new EnvironmentDefs();

const network = Network.create((operation, variables) => {
    let pjwt = localStorage.getItem("m_pjwt");
    if (pjwt == null) {
        pjwt = localStorage.getItem("pjwt");
    }

    return fetch(envDefs.getCoreWsUrl(), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('id_token'),
            'X-Requested-With': 'Bearer ' + pjwt,
        },
        body: JSON.stringify({
            query: operation.text,
            variables,
        })
    }).then(response => {
        //console.log('Ran fetch');
        return response.json()
    }).catch(reason => {
        // console.log('Fetch failed');
        // console.log(reason);
    })
});

const environment = new Environment({
    network,
    store,
});

export default class AbEnvironment {
    getEnvironment() {
        return environment;
    }

    getPjwt() {
        let pjwt = localStorage.getItem("m_pjwt");
        if (pjwt == null) {
            pjwt = localStorage.getItem("pjwt");
        }
        return pjwt;
    }

    isMasquerade () {
        let mrole = localStorage.getItem("m_role");
        if (mrole != null)
            return true;
        else
            return false;
    }

    getExtensionId() {
      let eId = localStorage.getItem("extension_id");
      if (eId != null) {
        return eId;
      } else {
        return null;
      }
    }

    goToExternalApp(action, customerAppId, appId, appLink) {
      // if an extension function is available, call that.  Otherwise, just go to the link.
      let extensionId = this.getExtensionId();
      if (extensionId != null) {
        let theMessage = {
          action: action,
          customerAppId: customerAppId,
          appId: appId,
          appLink: appLink
        }

        window.postMessage(theMessage);
      } else {
        window.open(appLink, "_blank");
      }
    }      
    
    getUserAttribute(attrName) {
        // Is there a masquerade?
        let mrole = localStorage.getItem("m_role");
        let atn = attrName;
        if (mrole != null) {
          atn = "m_" + attrName;
        }

        /*
        let theRet = localStorage.getItem(atn);
        return theRet;
        */
        return localStorage.getItem(atn);
    }

    /*
     * Used as a convenience for funding source contact info when the
     * funding source is the logged in account.  Can also be used as
     * bindcard contact for logged in account.
     */
    getAccountContact() {
        let uInfo = {
            accountId:        this.getUserAttribute('a_id'),
            accountName:      this.getUserAttribute('a_accountName'),
            description:      this.getUserAttribute('a_description'),
            firstName:        this.getUserAttribute('a_firstName'),
            lastName:         this.getUserAttribute('a_lastName'),
            email:            this.getUserAttribute('a_email'),
            phone:            this.getUserAttribute('a_phone'),
            address1:         this.getUserAttribute('a_address1'),
            address2:         this.getUserAttribute('a_address2'),
            city:             this.getUserAttribute('a_city'),
            state:            this.getUserAttribute('a_state'),
            country:          this.getUserAttribute('a_country'),
            postalCode:       this.getUserAttribute('a_postalCode'),
            dwollaCid:        this.getUserAttribute('a_dwollaCid'),
            stripeCid:        this.getUserAttribute('a_stripeCid'),
            hubspotId:        this.getUserAttribute('a_hsId'),
            achActive:        this.getUserAttribute('a_achActive')
        }

        return uInfo;
    }
    
    setUserAttribute(attrName, attrVal) {
        // Is there a masquerade?
        let mrole = localStorage.getItem("m_role");
        let atn = attrName;
        if (mrole != null) {
          atn = "m_" + attrName;
        }
    
        // If the value is null, remove it - the only way for it to
        // be null is to not exist.  (All local storage items are
        // persisted as non null strings - so passing a null results
        // in the string "null")
        if (attrVal == null)
            localStorage.removeItem(atn);
        else
            localStorage.setItem(atn, attrVal);
    }

    isSegmentActive() {
        return envDefs.isSegmentActive();
    }

    /* Get the flag values, return as an obj */
    getFlagValue(flagName) {
        let flagString = this.getUserAttribute('a_flags');
        if (flagString == null || flagString === '') {
            return null;
        }

        try {
            let flagJson = JSON.parse(flagString);
            if (flagJson.totalCount == null || flagJson.nodes == null) {
                return null;
            }

            if (flagJson.totalCount > 0) {
                for (let i=0; i<flagJson.nodes.length; i++) {
                    let theNode = flagJson.nodes[i];
                    if (theNode.flagName === flagName) {
                        let flagObj = {
                            flagName: theNode.flagName,
                            flagValue: theNode.flagValue,
                            flagValueTxt: theNode.flagValueTxt
                        };
                        return flagObj;
                    }
                }
            }

            return null;
        } catch (error) {
            return null;
        }
    }

    getDeclineReason(code) {
        let theTranslation = this.getDeclineTranslation(code);

        if (theTranslation === '') {
            //at this point we did not find an error match.  Return nothing for a user but return raw for us
            //note this is intentionally not looking at masq role.
            if (localStorage.getItem("role") === "appbind_appbind") {
                return ' Raw last reason code: ' + code;
            } else {
                return '';
            }
        } else {
            return ' Last decline reason: ' + theTranslation;
        }
    }

    getDeclineTranslation(code) {

        if (code === 'authentication_required') {
          return 'The card was declined as the transaction requires authentication.';
        } else if (code === 'approve_with_id') {
          return 'The payment cannot be authorized.';
        } else if (code === 'call_issuer') {
          return 'The card has been declined for an unknown reason.';
        } else if (code === 'card_not_supported') {
          return 'The card does not support this type of purchase.';
        } else if (code === 'card_velocity_exceeded') {
          return 'The customer has exceeded the balance or credit limit available on their card.';
        } else if (code === 'currency_not_supported') {
          return 'The card does not support the specified currency.';
        } else if (code === 'do_not_honor') {
          return 'The card has been declined for an unknown reason.';
        } else if (code === 'do_not_try_again') {
          return 'The card has been declined for an unknown reason.';
        } else if (code === 'duplicate_transaction') {
          return 'A transaction with identical amount and credit card information was submitted very recently.';
        } else if (code === 'expired_card') {
          return 'The card has expired.';
        } else if (code === 'fraudulent') {
          return 'The payment has been declined as Stripe suspects it is fraudulent.';
        } else if (code === 'generic_decline') {
          return 'The card has been declined for an unknown reason.';
        } else if (code === 'incorrect_number') {
          return 'The card number is incorrect.';
        } else if (code === 'incorrect_cvc') {
          return 'The CVC number is incorrect.';
        } else if (code === 'incorrect_pin') {
          return 'The PIN entered is incorrect. This decline code only applies to payments made with a card reader.';
        } else if (code === 'incorrect_zip') {
          return 'The ZIP/postal code is incorrect.';
        } else if (code === 'insufficient_funds') {
          return 'The card has insufficient funds to complete the purchase.';
        } else if (code === 'invalid_account') {
          return 'The card, or account the card is connected to, is invalid.';
        } else if (code === 'invalid_amount') {
          return 'The payment amount is invalid, or exceeds the amount that is allowed.';
        } else if (code === 'invalid_cvc') {
          return 'The CVC number is incorrect.';
        } else if (code === 'invalid_expiry_month') {
          return 'The expiration month is invalid.';
        } else if (code === 'invalid_expiry_year') {
          return 'The expiration year is invalid.';
        } else if (code === 'invalid_number') {
          return 'The card number is incorrect.';
        } else if (code === 'invalid_pin') {
          return 'The PIN entered is incorrect. This decline code only applies to payments made with a card reader.';
        } else if (code === 'issuer_not_available') {
          return 'The card issuer could not be reached, so the payment could not be authorized.';
        } else if (code === 'lost_card') {
          return 'The payment has been declined because the card is reported lost.';
        } else if (code === 'merchant_blacklist') {
          return 'The payment has been declined because it matches a value on the Stripe user’s block list.';
        } else if (code === 'new_account_information_available') {
          return 'The card, or account the card is connected to, is invalid.';
        } else if (code === 'no_action_taken') {
          return 'The card has been declined for an unknown reason.';
        } else if (code === 'not_permitted') {
          return 'The payment is not permitted.';
        } else if (code === 'offline_pin_required') {
          return 'The card has been declined as it requires a PIN.';
        } else if (code === 'online_or_offline_pin_required') {
          return 'The card has been declined as it requires a PIN.';
        } else if (code === 'pickup_card') {
          return 'The card cannot be used to make this payment (it is possible it has been reported lost or stolen).';
        } else if (code === 'pin_try_exceeded') {
          return 'The allowable number of PIN tries has been exceeded.';
        } else if (code === 'processing_error') {
          return 'An error occurred while processing the card.';
        } else if (code === 'reenter_transaction') {
          return 'The payment could not be processed by the issuer for an unknown reason.';
        } else if (code === 'restricted_card') {
          return 'The card cannot be used to make this payment (it is possible it has been reported lost or stolen).';
        } else if (code === 'revocation_of_all_authorizations') {
          return 'The card has been declined for an unknown reason.';
        } else if (code === 'revocation_of_authorization') {
          return 'The card has been declined for an unknown reason.';
        } else if (code === 'security_violation') {
          return 'The card has been declined for an unknown reason.';
        } else if (code === 'service_not_allowed') {
          return 'The card has been declined for an unknown reason.';
        } else if (code === 'stolen_card') {
          return 'The payment has been declined because the card is reported stolen.';
        } else if (code === 'stop_payment_order') {
          return 'The card has been declined for an unknown reason.';
        } else if (code === 'transaction_not_allowed') {
          return 'The card has been declined for an unknown reason.';
        } else if (code === 'try_again_later') {
          return 'The card has been declined for an unknown reason.';
        } else if (code === 'withdrawal_count_limit_exceeded') {
          return 'The customer has exceeded the balance or credit limit available on their card.';
        } else if (code === 'Dwolla payment failed') {
          return 'This ACH transaction did not complete successfully';
        } else if (code === 'Dwolla payment cancelled') {
          return 'This ACH transaction was cancelled';
        }

        return '';
    }
}